module.exports = __webpack_public_path__ + "static/img/main-background.74a75d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main-background.jpg
// module id = TuFs
// module chunks = 3